import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import NpiProjectHeaderComponent from "./npi-project-header.component";
import NpiProjectMetricsComponent from "./npi-project-metrics.component";
import NpiActivityGroupComponent from "./npi-activity-group.component";
import { BaseService } from "../../../../../services/base-service";
import { URLS } from "../../../../../services/app-urls";
import { NpiActivityStatus, NpiProject } from "../types/npi-project.types";
import { mapNpiDetailToProject } from "../utils/map-npi-detail";
import { ErrorComponent } from "../../../../../components/error/error.component";

const NpiProjectPlanningComponent = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    const [project, setProject] = useState<NpiProject | null>(null);

    const npiTaskService = new BaseService<any>(URLS.NPI_TASK);

    const loadProject = useCallback(() => {
        if (!id) {
            return Promise.resolve();
        }
        const npiService = new BaseService<any>(URLS.NPI);
        return npiService.getById(id).then((response) => {
            setProject(mapNpiDetailToProject(response.data));
        });
    }, [id]);

    useEffect(() => {
        loadProject();
    }, [loadProject]);

    const handleDurationChange = (activityId: number, duration: number) => {
        npiTaskService.patch({ duration }, activityId).then(loadProject).catch((error: any) => {
            ErrorComponent(error);
        });
    };

    const handleStatusChange = (activityId: number, status: NpiActivityStatus) => {
        npiTaskService.patch({ status }, activityId).then(loadProject).catch((error: any) => {
            ErrorComponent(error);
        });
    };

    if (!project) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", pt: 6 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <section className="npi-project-planning-page" style={{ backgroundColor: "#F7F8FA", height: "100%", display: "flex", flexDirection: "column" }}>
            <div className="floating-title" style={{ flexShrink: 0 }}>
                <NpiProjectHeaderComponent
                    project={project}
                    onBack={() => navigate(-1)}
                />
            </div>

            <Box sx={{ backgroundColor: "#F7F8FA", pb: "25px", flex: 1, minHeight: 0, overflowY: "auto" }}>
                <NpiProjectMetricsComponent project={project} />
                <Box sx={{ px: "15px", pt: "16px" }}>
                    {project.groups.map((group) => (
                        <NpiActivityGroupComponent
                            key={group.id}
                            group={group}
                            onDurationChange={handleDurationChange}
                            onStatusChange={handleStatusChange}
                        />
                    ))}
                </Box>
            </Box>
        </section>
    );
};

export default NpiProjectPlanningComponent;
